<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>
<script>
export default {
  name: 'App',
  props: {
    source: String
  },
  watch: {
    user (val, oldval) {
      if (!val && oldval) {
        this.$router.push('/')
      }
    },
    '$route' (val) {
      if (!this.user && val.path !== '/' && val.path !== '/auth') {
        this.$router.push('/')
      }
      if (val.path && val.path !== '/' && val.path !== '/auth') {
        this.$store.commit('setLastPage', val.path)
      }
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    lastPage () {
      return this.$store.getters.lastPage
    }
  }
}
</script>
